// CB-REQ INV-A14 at v1.982 (VENUE EQUIP): how a quote or job line for a venue's own equipment says
// so. At its own venue it is included, at no charge and never packed, or (v1.989) sold for the
// venue at its rate; anywhere else it holds nothing and must be replaced with the company's own, as
// the pick list and invoice also say. Where whether it is charged is not known, it is the venue's.

export function VenueEquipmentLabel({
  venueEquipment,
}: {
  venueEquipment:
    { here: boolean; venueName?: string; charged?: boolean | undefined } | null | undefined;
}) {
  if (!venueEquipment) return null;
  return venueEquipment.here ? (
    <span className="tag mt-1 block w-fit font-normal">
      {venueEquipment.charged === false ? 'Included by the venue' : 'Venue’s own'}
    </span>
  ) : (
    <span className="mt-1 block text-xs font-semibold text-accent-2-700">
      {venueEquipment.venueName ? `${venueEquipment.venueName}’s` : 'Another venue’s'} equipment,
      not this venue’s: replace it
    </span>
  );
}

/**
 * INV-A14 at v1.983: the company's own item where the venue's hire already includes one of its
 * category. Allowed — gear is sometimes doubled — but said, so a reviewer sees it.
 */
export function VenueIncludesWarning({
  venueIncludes,
}: {
  venueIncludes: { itemName: string; roomName: string | null } | null | undefined;
}) {
  if (!venueIncludes) return null;
  return (
    <span className="mt-1 block text-xs font-semibold text-accent-2-700">
      The venue includes {venueIncludes.itemName}
      {venueIncludes.roomName ? ` in ${venueIncludes.roomName}` : ''}
    </span>
  );
}

/**
 * INV-A14 at v1.991: what to do about short lines. The tenant's own short gear is reserved once
 * stock frees up, or cross-hired; the venue's own short gear means the venue is short, and the
 * tenant covers it with its own. Said for the mix of the two.
 */
export function shortAdvice(
  lines: ReadonlyArray<{
    venueEquipment?: { here: boolean } | null | undefined;
    availability?: { short: number } | null | undefined;
  }>,
  shortLines: number,
): { own: number; venue: number } {
  const venue = lines.filter(
    (l) => l.venueEquipment?.here && (l.availability?.short ?? 0) > 0,
  ).length;
  return { own: Math.max(shortLines - venue, 0), venue: Math.min(venue, shortLines) };
}

/** The venue's part of a shortage, as a sentence; empty when none of it is the venue's. */
export const venueShortSentence = (venue: number) =>
  venue === 0
    ? ''
    : `The venue is short of its own gear on ${venue === 1 ? 'one line' : `${venue} lines`}: cover it with yours.`;
